<template>
  <div class="flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vs-card class="page-bg-color p-6 changepass-card">
        <div class="heading mb-5">
          <h2 class="mb-4" align="center">{{ $t('labels.change_password') }}</h2>
          <p class="py-4" align="center">{{ $t('strings.change_pass_account') }}</p>
        </div>
        <vs-row class="flex w-full vx-row no-gutter items-center justify-center">
          <div class="vx-col sm:w-full md:w-full lg:w-1/1 d-theme-dark-bg">
            <form autocomplete="off" @submit.prevent="checkValidation()">
              <div class="vx-row mb-4">
                <div class="vx-col w-full p-0">
                  <vs-input
                    type="password"
                    class="w-full"
                    name="old_password"
                    :label="$t('labels.old_password')"
                    :placeholder="$t('labels.old_password')"
                    icon-pack="feather"
                    icon="icon-lock"
                    icon-no-border
                    v-model="old_password"
                    v-validate="'required'"
                  />
                  <span class="text-danger text-sm">{{ errors.first('old_password') }}</span>
                </div>
              </div>
              <div class="vx-row mt-6">
                <div class="vx-col w-full p-0">
                  <vs-input
                    type="password"
                    class="w-full"
                    name="new_password"
                    :label="$t('labels.new_password')"
                    icon-pack="feather"
                    icon="icon-lock"
                    icon-no-border
                    :placeholder="$t('labels.new_password')"
                    v-model="new_password"
                    ref="password"
                    v-validate="'required|min:6'"
                  />
                  <span class="text-danger text-sm">{{ errors.first('new_password') }}</span>
                </div>
              </div>
              <div class="vx-row mt-6">
                <div class="vx-col w-full p-0">
                  <vs-input
                    type="password"
                    class="w-full"
                    name="password_confirmation"
                    :label="$t('labels.confirm_password')"
                    icon-pack="feather"
                    icon="icon-lock"
                    icon-no-border
                    :placeholder="$t('labels.confirm_password')"
                    v-model="confirm_password"
                    v-validate="'required|confirmed:password'"
                  />

                  <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>
                </div>
              </div>

              <div class="vx-row mt-6">
                <div class="vx-col w-full p-0">
                  <div class="flex mt-5 justify-center" align="center">
                    <vs-button
                      color="primary"
                      class="mr-4 back-btn"
                      @click="goBack()"
                    >{{ $t('labels.cancel') }}</vs-button>
                    <vs-button
                      class="vs-component vs-button md:w-auto mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
                      :disabled="button_loading"
                      button="submit"
                      id="change-password"
                    >{{$t('labels.change_password')}}</vs-button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </vs-row>
      </vs-card>
    </div>
  </div>
</template>
<script>
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "getChangePasswordField",
  mutationType: "updateChangePasswordField"
});

export default {
  computed: {
    ...mapFields(["old_password", "new_password", "confirm_password"])
  },
  mounted() {
    this.setValidationMessage();
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.changePassword();
        }
      });
    },
    async changePassword() {
      let input = {
        current_password: this.old_password,
        password: this.new_password,
        password_confirmation: this.confirm_password
      };
      let response = await this.getHTTPPostResponse(
        "/change-password",
        input,
        "#change-password",
        true
      );
      if (response) {
        this.$validator.reset();
        // this.$router.push({ name: "Dashboard" });
        history.back();
      }
    },
    destroyed() {
      this.$store.commit("clearPasswordField", "changePassword", {
        module: "login"
      });
    },
    goBack() {
      history.back();
    }
  }
};
</script>
<style scoped>
button.login-btn {
  background: rgba(var(--vs-primary), 1) !important;
}
.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}
</style>


        